/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 09.09.25
 *
 */
import BaseObject from "@shared/BaseObject.js";
import {Type} from "@qwoach/class-transformer-wrapper";
import TimeIndexData from "@tl/core/modules/commission/model/timeBasedIndex/TimeIndexData";

export default class CommissionProgressInfo extends BaseObject {

	availableFunds: number = 0

	completedSessionsCount: number = 0
	totalSessionsCount: number = 0
	sessionCountBySourceServiceId: Object = null

	sessionsTsArray: [] = [] // [{id: sessionJournalEntryId, dateMs: timestamp, title: string}]

	@Type(() => TimeIndexData)
	activeTodosIndex: TimeIndexData = new TimeIndexData()

	@Type(() => TimeIndexData)
	upcomingSessionIndex: TimeIndexData = new TimeIndexData()


	constructor(options) {
		super(options);
	}




	getNextSessionInfo(){
		if(this.upcomingSessionIndex.nextActiveItem){
			return this.upcomingSessionIndex.nextActiveItem
		}
		return null
	}
	getActiveTodoIndexList(){
		return this.activeTodosIndex.activeItems
	}
	hiddenActiveItemsNumber(){
		return this.activeTodosIndex.hiddenActiveItemsNumber
	}

	hasSessionCountBySourceServiceIdMap() {
		return !!this.sessionCountBySourceServiceId
	}

	getSessionCountBySourceServiceIdMap() {
		return this.sessionCountBySourceServiceId || null
	}

	setSessionCountBySourceServiceIdMap(sessionCountBySourceServiceId = null) {
		this.sessionCountBySourceServiceId = sessionCountBySourceServiceId || null
		this.totalSessionsCount = Object.values(this.sessionCountBySourceServiceId || {})
			.reduce((sum, count) => sum + (Number(count) || 0), 0)
		return this.sessionCountBySourceServiceId
	}
}
